<div class="upsell-container">
  <h4>{{ "payment.addons-title" | translate }} </h4>
  @for (addOnList of upsellList; track addOnList; let i = $index) {
  <ion-row class="splitter-line-bottom">
    <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="checkbox-area">
      <ion-checkbox mode="ios" color="secondary" [value]="addOnList?.price[preferredCurrency]"
        (ionChange)="onCheckboxChange($event, addOnList)" [(ngModel)]="addOnList.isChecked">
      </ion-checkbox>
    </ion-col>
    <ion-col size="8" size-md="10" size-lg="10" size-xl="10" class="details"
      [innerHTML]="addOnList?.html_msg[selectedLanguage] | safeHtml">
    </ion-col>
    <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="price">
      <strong> {{currencySymbol}}{{addOnList?.price[preferredCurrency]}} </strong>
    </ion-col>
  </ion-row>
  }
</div>
